export default __webpack_public_path__ + "static/media/xlsError.742bf6d9.svg";